import type { SVGProps } from "react";
const SvgSteps = (props: SVGProps<SVGSVGElement>) => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18 18" {...props}>
        <path
            fill="currentColor"
            d="M15.65 6.65a2.35 2.35 0 1 1-2.242 3.057h-2.166a2.351 2.351 0 0 1-4.484 0H4.592A2.351 2.351 0 1 1 4.594 8.3h2.162a2.351 2.351 0 0 1 4.488 0h2.162a2.35 2.35 0 0 1 2.244-1.65M2.353 8.065a.938.938 0 1 0 0 1.875.938.938 0 0 0 0-1.875m6.65 0a.938.938 0 1 0 0 1.875.938.938 0 0 0 0-1.875m6.65 0a.938.938 0 1 0 0 1.875.938.938 0 0 0 0-1.875"
        />
    </svg>
);
export default SvgSteps;
